import { render, staticRenderFns } from "./EmployeeMovementTable.vue?vue&type=template&id=5ddfcff2&"
import script from "./EmployeeMovementTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeMovementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports